import { Navigate } from 'react-router';
import { PropsWithChildren, ReactElement } from 'react';
import { UserRole } from '@synergy/models';
import { hasRole } from '@synergy/utils';

import { User } from '../../models/user';

export interface AccessControlProps extends PropsWithChildren {
    allowedRoles?: UserRole | UserRole[];
    redirect?: boolean;
    user: User | null;
}

export const AccessControl = (props: AccessControlProps): ReactElement | null => {
    const { allowedRoles, redirect, user, children } = props;

    if (!user) {
        return null;
    }

    const allowed = !(allowedRoles && allowedRoles.length > 0) || hasRole(allowedRoles, user);

    if (allowed) {
        // eslint-disable-next-line react/jsx-no-useless-fragment
        return <>{children}</>;
    }

    if (redirect) {
        return <Navigate to="/" />;
    }
    return null;
};
